import { render, staticRenderFns } from "./ModalPreencherDadosGestor.vue?vue&type=template&id=d06fa7be&scoped=true"
import script from "./ModalPreencherDadosGestor.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPreencherDadosGestor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalPreencherDadosGestor.vue?vue&type=style&index=0&id=d06fa7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06fa7be",
  null
  
)

export default component.exports